module.exports = __webpack_public_path__ + "static/media/brewit.b81c240b.jpg";